import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/react/24/outline';
import styles from './ClientProject.module.css';
import {projectRequestListAPI} from '../../../services/client';
import ClientProjectRequestInfo from "./ClientProjectRequestInfo";

interface ClientProjectRequestProps {
    projectRequestId: number;
}
//프로젝트 추가 요청 상세 페이지 버튼
const ClientProjectRequest: React.FC<ClientProjectRequestProps> = ({projectRequestId}) => {
    const navigate = useNavigate();
    const [projectIds, setProjectIds] = useState<number[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                //프로젝트 추가 요청 식별자 목록 API
                const response = await projectRequestListAPI();
                setProjectIds(response);
                const index = response.findIndex(pid => pid === projectRequestId);
                setCurrentIndex(index);
            } catch (error) {
                console.error('Error fetching project requests:', error);
            }
        };

        fetchProjects();
    }, [projectRequestId]);

    //이전 요청 페이지
    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevProjectId = projectIds[currentIndex - 1];
            navigate(`/client/projects/project-request/${prevProjectId}`);
        }
    };

    //다음 요청 페이지
    const handleNext = () => {
        if (currentIndex < projectIds.length - 1) {
            const nextProjectId = projectIds[currentIndex + 1];
            navigate(`/client/projects/project-request/${nextProjectId}`);
        }
    };

    //프로젝트 추가 요청 식별자가 없는 경우
    if (!projectRequestId) {
        return <div>Invalid project request ID</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.navigationContainer}>
                {/*이전 요청 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === 0 ? styles.disabled : ''}`}
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                    aria-label="Previous project request"
                >
                    <ChevronLeftIcon className={styles.navIcon}/>
                </button>

                <div className={styles.contentWrapper}>
                    {/*프로젝트 추가 요청 정보*/}
                    <ClientProjectRequestInfo projectRequestId={projectRequestId}/>
                </div>

                {/*다음 요청 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === projectIds.length - 1 ? styles.disabled : ''}`}
                    onClick={handleNext}
                    disabled={currentIndex === projectIds.length - 1}
                    aria-label="Next project request"
                >
                    <ChevronRightIcon className={styles.navIcon}/>
                </button>
            </div>
        </div>
    );
};

export default ClientProjectRequest;